import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUserLine = (props) => /* @__PURE__ */ _jsx("svg", {
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M25.6 23c-1.794 0-2.656 1-5.6 1-2.944 0-3.8-1-5.6-1A8.402 8.402 0 0 0 6 31.4V33a3 3 0 0 0 3 3h22a3 3 0 0 0 3-3v-1.6c0-4.637-3.762-8.4-8.4-8.4ZM31 33H9v-1.6a5.41 5.41 0 0 1 5.4-5.4c.912 0 2.394 1 5.6 1 3.231 0 4.681-1 5.6-1a5.41 5.41 0 0 1 5.4 5.4V33ZM20 22c4.969 0 9-4.031 9-9s-4.031-9-9-9-9 4.031-9 9 4.031 9 9 9Zm0-15c3.306 0 6 2.694 6 6s-2.694 6-6 6a6.01 6.01 0 0 1-6-6c0-3.306 2.694-6 6-6Z" })
});
export default SvgUserLine;
